<template>

<!-- <nav class="navbar navbar-light border-bottom" role="navigation" aria-label="main navigation"> -->
<nav class="flex justify-center items-center h-32 font-bold text-sm border-b border-gray-200 bg-white py-3" role="navigation" aria-label="main navigation">
    
    <!-- LEFT Section: Logo -->
    <!-- <div class="flex items-center space-x-2 pl-4"> -->
    <div class="flex items-center justify-end w-[60vw] sm:w-[20vw] lg:w-[18vw] 2xl:w-[16vw] space-x-1 xl:space-x-2 2xl:space-x-3 3xl:space-x-5">
        <a class="" :href="app_url">
            <img src="./assets/site/img/GeoSphere-Tethys-Logo-Header.svg" class="h-[60px] lg:h-[72px] xl:h-[72px] 2xl:h-20 3xl:h-24"/>
        </a>
        <!-- Separator -->
        <span class="hidden md:block h-10 xl:h-11 2xl:h-14 3xl:h-16 w-0.5 bg-gray-400"></span>
    </div>
    <!-- CENTER Section: Repository name -->
    <div class="flex flex-col sm:w-[60vw] lg:w-[63vw] 2xl:w-[67vw] ml-1 md:pl-1 lg:pl-2 xl:pl-4 2xl:pl-5">
        <span class="text-gray-500 text-xs sm:text-sm xl:text-lg 2xl:text-xl font-normal">Tethys Research Data Repository</span>
        <span class="text-gray-400 text-xs xl:text-sm font-normal">Certified publisher for geoscientific research data</span>
    </div> 


    <!-- RIGHT Section: AboutUs icon, Login and Language Selector -->
    <!-- <div class="hidden md:flex items-end space-x-2 xl:space-x-3 2xl:space-x-5 lg:pr-2 xl:pr-5 2xl:pb-5"> -->
    <div class="hidden md:flex w-[20vw] lg:w-[18vw] 2xl:w-[16vw] items-start justify-left pt-10 space-x-0 lg:space-x-1 2xl:space-x-3 3xl:space-x-5 ">

        <!-- About Us button -->
        <a 
            v-bind:href="'https://gis.geosphere.at/tethys'" 
            target="_self"
            class="flex items-center py-2 pr-2 text-gray-800 text-xs lg:text-sm hover:bg-gray-100 focus:outline-none rounded-md"
            :title="$t('tooltips.question_button')"
        >
            <i class="fa-solid fa-circle-question"></i>
        </a>

        <!-- Login button -->
        <a 
            v-bind:href="portal" 
            target="_blank"
            class="flex items-center py-1 px-2 text-gray-800 text-xs lg:text-sm hover:bg-gray-100 focus:outline-none rounded-md"
        >
            <strong>{{ $t("login") }}</strong>
        </a>

        <!-- Separator -->
        <div class="h-6 lg:h-8 w-[1px] lg:w-[2px] bg-gray-800"></div>

        <!-- Language Selection -->
        <div class="relative">
            <button 
                class="flex space-x-2 items-center py-1 px-2 text-gray-800 hover:bg-gray-100 focus:outline-none rounded-md" 
                :title="$t('select_details_language')"
                @click="dropdownOpen = !dropdownOpen"
            >
                <span class="text-xs lg:text-sm 2xl:text-md font-bold">{{ $i18n.locale.toUpperCase() }}</span>
                <svg class="h-4 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </button>

            <!-- Dropdown Menu -->
            <div v-show="dropdownOpen" class="absolute mt-1 bg-white border border-gray-200 shadow-lg rounded-md z-10">
                <span class="text-xs lg:text-sm text-gray-800">
                    <span v-for="(locale, index) in $i18n.availableLocales" :key="`locale-${locale}`">
                        <!-- <a 
                            href="#" 
                            class="block px-4 py-2 text-gray-800 text-xs lg:text-sm hover:bg-gray-100 cursor-pointer"
                            :class="{ 'font-bold text-tethys-green-dark': locale === $i18n.locale }"
                            @click.prevent="changeLocale(locale)"
                        >
                            {{ locale.toUpperCase() }}
                        </a> -->
                        <a v-if="locale !== $i18n.locale" 
                            href="#" 
                            class="block px-4 py-2 text-gray-800 text-xs lg:text-sm hover:bg-gray-100 cursor-pointer"
                            :class="{ 'font-bold text-tethys-green-dark': locale === $i18n.locale }"
                            @click.prevent="changeLocale(locale)"
                        >
                            {{ locale.toUpperCase() }}
                        </a>
                    </span>
                </span>
            </div>
        </div> <!-- Language selection button -->

    </div> <!-- Right section -->

    <!-- MOBILE Menu Button -->
    <button 
        class="md:hidden flex items-center px-1 py-5 border rounded text-gray-600 border-gray-200 hover:text-gray-800 hover:border-gray-400 hover:bg-gray-100 mr-2"
        @click="showMobilemenu"
        aria-label="Toggle navigation"
    >
        <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"></path>
        </svg>
    </button>

    
</nav>


<!-- Mobile Menu (Dropdown) -->
<div v-if="active" class="md:hidden w-full bg-white shadow-md z-50">
    <!-- <span class="flex flex-col text-gray-800 uppercase">
        <li v-for="(route, index) in menuRoutes" :key="index">
            <router-link 
                class="block px-6 py-3 border hover:bg-gray-100 text-gray-500"
                :class="{ 'font-bold border-l ': isActive(route.path) }"
                :to="route.path"
                @click="active = false"
            >
                {{ $t(route.label) }}
            </router-link>
        </li>
    </span> -->

    <span class="flex justify-between items-center px-4 py-3 border-t border-gray-400">
        <!-- About us button -->
        <a v-bind:href="'https://gis.geosphere.at'" target="_self" class="text-gray-800 text-lg">
            <!-- <strong>{{ $t("login") }}</strong> -->
            <i class="fa-solid fa-circle-question"></i>
        </a>

        <!-- Login button -->
        <a v-bind:href="portal" target="_blank" class="text-gray-800 text-sm">
            <strong>{{ $t("login") }}</strong>
        </a>
        
        <!-- Language Selection -->
        <div>
            <button 
                class="flex py-2 px-2 items-center space-x-2 text-gray-800 hover:bg-gray-100 focus:outline-none" 
                :title="$t('select_details_language')"
                @click="dropdownOpen = !dropdownOpen"
            >
                <span class="text-xs lg:text-sm font-bold">{{ $i18n.locale.toUpperCase() }}</span>
                <svg class="h-4 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </button>

            <!-- v-show="dropdownOpen" -->
            <!-- Dropdown Menu -->
            <div v-show="dropdownOpen" class="absolute mt-1 ml-2 bg-white border border-gray-200 shadow-lg rounded-md z-10">
                <span class="text-sm text-gray-800">
                    <span v-for="(locale, index) in $i18n.availableLocales" :key="`locale-${locale}`">
                        <!-- <a 
                            href="#" 
                            class="block px-4 py-2 text-gray-800 hover:bg-gray-100 cursor-pointer"
                            :class="{ 'font-bold text-tethys-green-dark': locale === $i18n.locale }"
                            @click.prevent="changeLocale(locale)"
                        >
                            {{ locale.toUpperCase() }}
                        </a> -->
                        <a v-if="locale !== $i18n.locale" 
                            href="#" 
                            class="block px-4 py-2 text-gray-800 hover:bg-gray-100 cursor-pointer"
                            :class="{ 'font-bold text-tethys-green-dark': locale === $i18n.locale }"
                            @click.prevent="changeLocale(locale)"
                        >
                            {{ locale.toUpperCase() }}
                        </a>
                    </span>
                </span>
            </div>
        </div> <!-- Language selection button  -->
    </span>

</div>



<router-view></router-view>



<footer class="flex flex-wrap sm:h-[660px] xl:h-[700px] 2xl:h-[900px] text-sm sm:text-xs 2xl:text-sm">
    
    <!-- Tethys footer -->
    <div class="w-full flex flex-wrap bg-tethys-6 h-2/3">

        <!-- Logos container -->
        <!-- <div class="flex w-4/6 h-1/3 mx-auto justify-evenly font-bold text-center text-gray-50 text-opacity-40"> -->
        <div class="grid grid-cols-2 gap-4 sm:flex sm:flex-wrap sm:gap-0 w-4/6 h-1/3 mx-auto justify-evenly font-bold text-center text-gray-50 text-opacity-40">
            <div class="flex flex-col pt-12 items-center">
                <span class="mb-[20px]">{{ $t('footer.certified_by') }}</span>
                <a target="_blank" href="https://dataverse.nl/dataset.xhtml?persistentId=doi:10.34894/TKWVFL">
                    <img src="./assets/site/img/CoreTrustSeal-Logo-Footer.svg" class="h-14 sm:h-12 2xl:h-16" />
                </a>
            </div>
            <div class="flex flex-col pt-12">
                <span class="mb-8">{{ $t('footer.registered_at') }}</span>
                <a target="_blank" href="https://www.re3data.org/repository/r3d100013400">
                    <img src="./assets/site/img/Re3data-Logo-Footer.svg" class="h-8 sm:h-7 2xl:h-10" />
                </a>
            </div>
            <div class="flex flex-col pt-12">
                <span class="mb-8">{{ $t('footer.listed_in') }}</span>
                <a target="_blank" href="https://www.base-search.net/Search/Results?q=coll:fttethysrdr&refid=dctablede">
                    <img src="./assets/site/img/BASE-Logo-Footer.svg" class="h-9 sm:h-8 2xl:h-12" />
                </a>
            </div>
            <div class="flex flex-col pt-12">
                <span class="mb-8">{{ $t('footer.indexed_in') }}</span>
                <a target="_blank" href="https://explore.openaire.eu/search/dataprovider?pid=r3d100013400">
                    <img src="./assets/site/img/OpenAIRE-Logo-Footer.svg" class="h-8 sm:h-7 2xl:h-10" />
                </a>
            </div>
        </div>

        <!-- Line under logos -->
        <div class="flex w-4/6 pt-10 sm:pt-5 2xl:pt-0 mx-auto justify-evenly border-b-2 border-b-white border-opacity-20"></div>

        <!-- Tethys info content -->
         <!-- grid grid-cols-2 gap-6 sm:flex sm:flex-wrap sm:gap-0 -->
        <div class="flex flex-wrap sm:flex-nowrap lg:w-11/12 xl:w-10/12 h-2/3 text-white mx-auto justify-evenly items-start">
            <!-- Tethys logo and info -->
            <div class="flex flex-col sm:w-[33vw] lg:w-2/5">
                <span></span>
                <img src="./assets/site/img/GeoSphere-Tethys-Logo-Footer.svg" class="w-52 2xl:w-60 pt-8 2xl:pt-20 pb-1" alt="">
                <span class="pl-16 2xl:pl-20 pb-2 ml-2">
                    Tethys Research<br>
                    Data Repository
                </span>
                <span class="pl-16 2xl:pl-20 ml-2">
                    Publisher for<br>
                    geoscientific research data
                </span>
            </div>
            <!-- Contact block -->
            <div class="flex flex-col ml-24 sm:ml-0 w-full sm:w-[22vw] lg:w-1/5">
                <div class="">
                    <div class="uppercase sm:text-sm lg:text-base 2xl:text-lg font-bold pt-20 2xl:pt-32 pb-5">{{ $t('footer.contact') }}</div>
                    <div class="leading-relaxed pb-2">
                        GeoSphere Austria<br>
                        Standort Neulinggasse 38,<br>
                        1030 Wien<br>
                    </div>
                    <i class="fa-solid fa-phone text-base py-1 pr-1"></i> +43 1 7125674<br>
                    <i class="fa-solid fa-envelope text-base py-1 pr-1"></i> repository@geosphere.at
                </div>
            </div>
            <!-- About block -->
            <div class="flex flex-col ml-24 sm:ml-0 w-full sm:w-[22vw] lg:w-1/5">
                <div class="pt-20 2xl:pt-32">
                    <div class="uppercase sm:text-sm lg:text-base 2xl:text-lg font-bold pb-5">{{ $t('footer.about_tethys') }}</div>
                    <a href="https://gis.geosphere.at/tethys" class="block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5">{{ $t('footer.about_tethys_links.news') }}</a>
                    <a href="https://gis.geosphere.at/tethys#info" class="block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5">{{ $t('footer.about_tethys_links.info') }}</a>
                    <a href="docs/HandbuchTethys.pdf" target="_blank" class="block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5">{{ $t('footer.about_tethys_links.manual') }}</a>
                    <a href="docs/PreservationPlanTethys.pdf" target="_blank" class="block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5" >{{ $t('footer.about_tethys_links.preservation_plan') }}</a>
                    <!-- <li class="list-none">
                        <router-link to="/docs/HandbuchTethys.pdf" target="_blank" class="block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5">
                            {{ $t('footer.about_tethys_links.manual') }}
                        </router-link>
                    </li>
                    <li class="list-none">
                        <router-link to="/docs/PreservationPlanTethys.pdf" target="_blank" class="block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5">
                            {{ $t('footer.about_tethys_links.preservation_plan') }}
                        </router-link>
                    </li> -->
                    <a href="#" class="block text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-0.5">{{ $t('footer.about_tethys_links.imprint') }}</a>
                </div>
            </div>
            <!-- Tools and support block -->
            <div class="flex flex-col ml-24 sm:ml-0 w-full sm:w-[22vw] lg:w-1/5 pb-12 sm:pb-0">
                <div class="pt-20 2xl:pt-32">
                    <div class="uppercase sm:text-sm lg:text-base 2xl:text-lg font-bold pb-5">{{ $t('footer.tools_support') }}</div>
                    <li class="list-none py-1" >
                        <a href="https://gis.geosphere.at/tethys#faqs" class="text-md text-gray-50 hover:text-tethys-green-dark transition-colors duration-200">
                            <i class="fa-regular fa-circle-question pr-2 text-base"></i>{{ $t('footer.tools_support_links.faqs') }}
                        </a>
                    </li>
                    <!-- <li class="list-none py-1" >
                        <router-link class="text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1" to="/oai">
                            <i class="fa-solid fa-circle-nodes pr-1 text-base"></i> OAI
                        </router-link>
                    </li>
                    <li class="list-none py-1" >
                        <router-link class="text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1" to="/sitelinks">
                            <i class="fa-solid fa-link pr-1 text-sm"></i> Sitelinks
                        </router-link>
                    </li>
                    <li class="list-none py-1">
                        <router-link class="text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1" to="/terms-and-conditions">
                            <i class="fa-solid fa-file-lines pl-1 pr-2 text-base"></i>{{ $t('footer.tools_support_links.terms_conditions') }}
                        </router-link>
                    </li> -->

                    <li class="list-none py-1">
                        <a class="text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1" :href="`${app_url}/oai`">
                            <i class="fa-solid fa-circle-nodes pr-1 text-base"></i> OAI
                        </a>
                    </li>
                    <li class="list-none py-1">
                        <a class="text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1" :href="`${app_url}/sitelinks`">
                            <i class="fa-solid fa-link pr-1 text-sm"></i> Sitelinks
                        </a>
                    </li>
                    <li class="list-none py-1">
                        <a class="text-gray-50 hover:text-tethys-green-dark transition-colors duration-200 py-1" :href="`${app_url}/terms-and-conditions`">
                            <i class="fa-solid fa-file-lines pl-1 pr-2 text-base"></i>{{ $t('footer.tools_support_links.terms_conditions') }}
                        </a>
                    </li>

                </div>
            </div>
        </div>

    </div>

    <!-- GeoSphere footer -->
    <div class="w-full flex flex-wrap bg-geosphere-midnight-green h-1/3">
        
        <div class="flex flex-wrap sm:flex-nowrap lg:w-11/12 xl:w-10/12 text-white mx-auto justify-evenly items-start">
            <!-- GeoSphere logo and info -->
            <div class="flex flex-col sm:w-[33vw] lg:w-2/5">
                <a :href="`https://www.geosphere.at/${$i18n.locale.toLowerCase()}`">
                    <img src="./assets/site/img/GSA_LogoMitZusatz_NegativAufMidnightGreen_RGB_XXS.svg" class="w-44 2xl:w-56 pt-10 pb-10 pl-2" alt="">
                </a>
            </div>

            <!-- Contact block -->
            <div class="flex flex-col ml-24 sm:ml-0 w-full sm:pt-16 lg:pt-20 2xl:pt-24 sm:w-[22vw] lg:w-1/5">
                <a :href="`https://www.geosphere.at/${$i18n.locale.toLowerCase()}`" class="text-xs lg:text-sm 2xl:text-base font-bold pb-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">
                    <i class="fa-solid fa-house pr-1"></i> www.geosphere.at
                </a>
                <div class="">
                    <div class="leading-relaxed pb-2">
                        GeoSphere Austria<br>
                        Hohe Warte 38,<br>
                        1190 Wien<br>
                    </div>
                </div>

            </div>
            
             <!-- Social media links -->
             <div class="flex flex-col sm:pt-14 lg:pt-20 2xl:pt-24 sm:w-[44vw] lg:w-2/5">
                <!-- Links container -->
                <div class="w-full grid grid-cols-2 lg:grid-cols-3 gap-x-4 py-7 sm:py-0">

                    <!-- Instagram -->
                    <div class="flex items-center py-2 px-2">
                        <a target="_blank" href="https://www.instagram.com/GeoSphere_AT" rel="noreferrer"
                            class="flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">
                            <img src="./assets/site/img/instagram.svg"
                                class="h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8">
                            <span>Instagram</span>
                        </a>
                    </div>

                    <!-- X -->
                    <div class="flex items-center py-2 px-2">
                        <a target="_blank" rel="noreferrer" href="https://x.com/GeoSphere_AT"
                            class="flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">
                            <img src="./assets/site/img/x-twitter.svg"
                                class="h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8">
                            <span>X</span>
                        </a>
                    </div>

                    <!-- YouTube -->
                    <div class="flex items-center py-2 px-2">
                        <a target="_blank" rel="noreferrer" href="https://www.youtube.com/@geosphereaustria2023"
                            class="flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">
                            <img src="./assets/site/img/youtube.svg" class="h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8">
                            <span>YouTube</span>
                        </a>
                    </div>

                    <!-- Facebook -->
                    <div class="flex items-center py-2 px-2">
                        <a target="_blank" rel="noreferrer" href="https://www.facebook.com/GeoSphere.at"
                            class="flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">
                            <img src="./assets/site/img/facebook.svg" class="h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8">
                            <span>Facebook</span>
                        </a>
                    </div>

                    <!-- LinkedIn -->
                    <div class="flex items-center py-2 px-2">
                        <a target="_blank" rel="noreferrer" href="https://at.linkedin.com/company/geosphereaustria"
                            class="flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">
                            <img src="./assets/site/img/linkedin.svg" class="h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8">
                            <span>LinkedIn</span>
                        </a>
                    </div>
                    
                    <!-- Flickr -->
                    <div class="flex items-center py-2 px-2">
                        <a target="_blank" rel="noreferrer" href="https://www.flickr.com/photos/geosphere_austria"
                            class="flex items-center space-x-2 text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">
                            <img src="./assets/site/img/flickr.svg" class="h-6 w-6 lg:h-7 lg:w-7 2xl:h-8 2xl:w-8">
                            <span>Flickr</span>
                        </a>
                    </div>

                </div>
            </div>

        </div>

        <div class="w-11/12 lg:w-10/12 flex text-white mx-auto justify-evenly items-start">
            <!-- Empty area to keep simmetry -->
            <div class="flex flex-col sm:w-[33vw] lg:w-2/5"></div>
            <!-- Bottom Legal Links  -->
            <div class="flex flex-col sm:w-[66vw] lg:w-3/5">
                <div class="w-full text-left text-gray-400 text-xs 2xl:text-sm space-x-3 lg:space-x-5">
                    <a :href="$t('footer.urls.impressum')" class="text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">{{ $t('footer.legal_links.impressum') }} </a>
                    <span class="border-r-2 border-r-geosphere-lemon"></span>
                    <a :href="$t('footer.urls.datenschutz')" class="text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">{{ $t('footer.legal_links.datenschutz') }}</a>
                    <span class="border-r-2 border-r-geosphere-lemon"></span>
                    <a :href="$t('footer.urls.legal')" class="text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">{{ $t('footer.legal_links.legal') }}</a>
                    <span class="border-r-2 border-r-geosphere-lemon"></span>
                    <a :href="$t('footer.urls.barrierefreiheit')" class="text-gray-50 hover:text-geosphere-lemon transition-colors duration-200">{{ $t('footer.legal_links.barrierefreiheit') }}</a>
                </div>
            </div>
        </div>

    </div>

</footer>

</template>

<script lang="ts">
import App2 from "./app2";
export default App2;
</script>

<style scoped lang="scss">
/* Smooth dropdown animation */
nav div {
    transition: all 0.3s ease-in-out;
}

</style>
